import reduceReducers from 'reduce-reducers';

//Siblings reducers
import consultationReducer from './consultationReducer';

export default reduceReducers(consultationReducer);
